import axios from "axios";
import { toast } from "react-toastify";
import { logout } from "../redux/authSlice";

const api = axios.create({
  // baseURL: "http://localhost:8000/api/v1",
  baseURL: "https://api.houfalmanazel.com/api/v1",
  // baseURL: "https://dev.houfalmanazel.com/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

let store;
export const injectStore = (_store) => {
  store = _store;
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage directly (for initial requests before store is injected)
    const token = localStorage.getItem("token");

    // If store is available, use the token from the store
    if (store) {
      const storeToken = store.getState().auth.token;
      if (storeToken) {
        config.headers["Authorization"] = `Bearer ${storeToken}`;
        return config;
      }
    }

    // Fallback to localStorage token
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors (token expired, invalid, etc.)
    if (error.response && error.response.status === 401 && store) {
      // Use the named action creator instead of direct dispatch by type
      store.dispatch(logout());
      toast.error("Your session has expired. Please log in again.");
    }
    // Handle server errors
    else if (error.response && error.response.status >= 500) {
      toast.error("Server error. Please try again later.");
    }
    // Handle client errors with response
    else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      toast.error(error.response.data.message);
    }
    // Handle network errors
    else if (error.request) {
      toast.error("Network error. Please check your connection.");
    }
    // Handle unexpected errors
    else {
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

export default api;
